// frontend/src/utils/print.js
//
// Impresión de un ÁMBITO concreto de la pantalla (no de toda la página).
//
// Uso:
//   <Box className="aps-print-area"> …contenido imprimible… </Box>
//   <Button className="aps-no-print" onClick={() => printSection()}>Imprimir</Button>
//
// El resto de la interfaz (sidebar, navbar, botones) queda fuera del papel por
// las reglas de `styles/print.css`.

const PRINTING_CLASS = 'aps-printing';

/** Lanza el diálogo de impresión limitado al bloque `.aps-print-area`. */
export const printSection = () => {
  const body = document.body;
  body.classList.add(PRINTING_CLASS);

  const cleanup = () => {
    body.classList.remove(PRINTING_CLASS);
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup);

  // Un frame para que el navegador aplique las reglas antes de abrir el diálogo.
  window.requestAnimationFrame(() => {
    window.print();
    // Respaldo: algunos navegadores no emiten `afterprint` de forma fiable.
    window.setTimeout(cleanup, 1500);
  });
};

/** Fecha legible para el encabezado impreso. */
export const printTimestamp = (locale = 'es-MX') => {
  try {
    return new Date().toLocaleString(locale, {
      year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit',
    });
  } catch (_) {
    return new Date().toISOString();
  }
};

export default printSection;
